import axios from "axios";
import { adminApi, API_BASE } from "@/api/adminClient";

/** Publiek: alleen gepubliceerde documenten (voor /leden). */
export const fetchDocuments = async () => {
  const res = await axios.get(`${API_BASE}/documents`);
  return res.data;
};

export const documentViewUrl = (id) => `${API_BASE}/documents/${id}/file`;
export const documentDownloadUrl = (id) => `${API_BASE}/documents/${id}/file?download=true`;

// ---------------------------------------------------------------- beheer

export const fetchAdminDocuments = async () => {
  const res = await adminApi.get("/admin/documents");
  return res.data;
};

export const uploadAdminDocument = async ({ file, title, description, doc_date }) => {
  const form = new FormData();
  form.append("file", file);
  form.append("title", title);
  form.append("description", description || "");
  form.append("doc_date", doc_date || "");
  const res = await adminApi.post("/admin/documents", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateAdminDocument = async (id, payload) => {
  const res = await adminApi.patch(`/admin/documents/${id}`, payload);
  return res.data;
};

export const deleteAdminDocument = async (id) => {
  const res = await adminApi.delete(`/admin/documents/${id}`);
  return res.data;
};
